import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import { TONE_CLASS, ICONS } from '../InspectionStatusBadge/InspectionStatusBadge';
import s from '../Inspection.css';

const TONE_ICON = { success: 'ok', danger: 'alert', warning: 'alert', info: 'clock', neutral: 'clock' };

// Message banner (success, warning, error, info). Errors are announced to screen readers; the icon doubles the colour.
export function InspectionBanner({ tone, title, children, role }) {
  const live = role || (tone === 'danger' ? 'alert' : 'status');
  return (
    <div className={cx(s.banner, s[TONE_CLASS[tone] || 'toneInfo'])} role={live}>
      <span aria-hidden="true">{ICONS[TONE_ICON[tone] || 'clock']}</span>
      <div>
        {title && <p className={s.bannerTitle}>{title}</p>}
        {children && <p className={s.bannerText}>{children}</p>}
      </div>
    </div>
  );
}

InspectionBanner.propTypes = { tone: PropTypes.string, title: PropTypes.node, children: PropTypes.node, role: PropTypes.string };
InspectionBanner.defaultProps = { tone: 'info' };

export default withStyles(s)(InspectionBanner);
